import React from 'react';
import PropTypes from 'prop-types';

import WistiaVideo from '../WistiaVideo/WistiaVideo';

import './StandAloneVideoModule.scss';

const StandaloneVideoModule = ({ title, text, videoId, ...props }) => {
  return (
    <div className="StandAloneVideoModule">
      <section className="StandAloneVideoModuleRow">
        <div className="StandAloneVideoModuleContentWrapper">
          <h2>{title}</h2>
          <p className="StandAloneVideoModuleMargin">{text}</p>
          <div className="StandAloneVideoModuleVideo">
            <div className="StandAloneVideoModuleVideoWrapper">
              <WistiaVideo videoId={videoId} />
            </div>
          </div>
        </div>
      </section>
      {props.children}
    </div>
  );
};

StandaloneVideoModule.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  videoId: PropTypes.node.isRequired,
};

export default StandaloneVideoModule;
